import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FormField } from "@/components/FormBits";
import { api, formatError } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <h1 className="font-display text-3xl font-extrabold tracking-tight">Esqueci minha senha</h1>
      <p className="mb-8 text-slate-500">Digite o e-mail da sua conta. Enviaremos um link para você criar uma nova senha.</p>
      <div className="space-y-4 rounded-md border border-slate-200 bg-white p-6">
        {sent ? (
          <div className="space-y-3" data-testid="forgot-sent">
            <div className="flex items-start gap-3 rounded-md bg-green-50 p-4 text-sm text-green-800">
              <MailCheck className="mt-0.5 h-5 w-5 shrink-0" />
              <span data-testid="forgot-sent-message">{sent}</span>
            </div>
            <p className="text-xs text-slate-500">Não chegou em alguns minutos? Confira a caixa de spam ou peça de novo.</p>
            <Button type="button" variant="outline" onClick={() => setSent("")} className="h-11 w-full rounded-full" data-testid="btn-forgot-again">Enviar de novo</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <FormField id="forgot-email" label="E-mail" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            <Button type="submit" disabled={busy} className="h-11 w-full rounded-full bg-slate-900 hover:bg-[#0099DD]" data-testid="forgot-submit">{busy ? "Enviando..." : "Enviar link"}</Button>
          </form>
        )}
        {error && <p className="rounded-md bg-red-50 p-3 text-sm text-red-700" data-testid="forgot-error">{error}</p>}
        <Link to="/entrar" className="block text-center text-sm font-semibold text-[#0099DD] hover:underline" data-testid="link-back-login">Voltar para o login</Link>
      </div>
    </div>
  );
}
